import React from 'react';
import { CurricularClass62023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass62023 />;
};

export default ExtraCurricularActivitiesPage;
